/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import {
  Tabs,
  Tab,
  Box,
  Typography,
  Tooltip,
  Paper,
  MenuItem,
  Slider,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import PropTypes from "prop-types";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import Button from "components/CustomButtons/Button";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import AuthContext from "../../contexts/AuthProvider.js";
import { client } from "../../services/axiosClient"; // Ensure this path is correct
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  getKpiSubtypeTranslation,
  getKpiTypeTranslation,
} from "utils/kpitranslationUtils.js";
import {
  faCalendarPlus,
  faCalendarMinus,
  faTable,
  faChartLine,
  faChartSimple,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
// Custom Project Styles
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle.js";
import { grayColor } from "assets/jss/material-dashboard-pro-react.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "jspdf-autotable";
import insightsLogo from "assets/img/insights_logo.PNG";
import Info from "@material-ui/icons/Info";
import { ThreeDots } from "react-loader-spinner"; // Spinner

// Utils
import { formatThresholds } from "utils/thresholdUtils";
import MixedBarLineChart from "../Orchestration/WhatsHappening/AuxComponents/MultiSeriesLineChartvBAR.js";
import { getProgressColor } from "../../utils/thresholdUtils.js";
import {
  lightenColor,
  darkenColor,
  pastelColorToRgb,
} from "../../utils/colorUtils";
import { generateKpiReportPdf } from "../../utils/pdfGenerator";

/**
 * COMMENT: This component handles the entire KPIs page, including both
 * Program KPIs and Initiative KPIs in separate tabs.
 */

// Helpers (you can rename the section as you wish)
// ---------------------------------------------------

function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

function hexToRgbArray(hex) {
  const cleanHex = hex.replace("#", "");
  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);
  return [r, g, b];
}

// ==================== STYLES ====================

const KPIEvolutionStyles = (theme, clientColor) => ({
  ...customSelectStyle(theme, clientColor),
  ...customInputStyle(clientColor),

  root: {
    padding: theme.spacing(1),
    minHeight: "100vh",
    transition: "background-color 0.8s ease",
    marginTop: "-30px",
  },
  tabsContainer: {
    backgroundColor: "#fff",
    borderRadius: "4px",
    marginBottom: theme.spacing(2),
    transition: "all 0.5s ease-in-out",
  },
  tabsRoot: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
  },
  tabPanel: {
    marginTop: theme.spacing(1),
  },
  tabRoot: {
    fontSize: "1rem",
    fontWeight: 400,
    color: "black",
    textTransform: "uppercase",
    "&:hover": {
      color: clientColor,
      opacity: 1,
    },
    "&.Mui-selected": {
      color: "black",
      fontWeight: 500,
    },
    "&:focus": {
      color: "black",
    },
  },
  indicator: {
    backgroundColor: clientColor,
    height: "1.5px",
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "0px",
    marginBottom: "0px",
    padding: "10px",
  },
  cardButton: {
    padding: "0 !important",
    margin: "0 !important",
    height: "30px !important",
    width: "30px !important",
    minWidth: "0 !important",
    position: "relative",
    transition: "all 0.2s",
  },
  cardButtonIcon: {
    margin: "0 !important",
    position: "absolute !important",
    top: "50% !important",
    left: "50% !important",
    transform: "translate(-50%, -50%)",
    width: "18px !important",
    height: "18px !important",
  },
  filterContainer: {
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  chartContainer: {
    height: "250px",
    marginTop: theme.spacing(2),
  },
  toolbarRow: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "8px",
    marginRight: "8px",
    marginBottom: "8px",
  },
  KPIsEvolutionHeader: {
    textAlign: "center",
    paddingBottom: "5px",
    paddingTop: "5px",
    fontWeight: 500,
    fontSize: "20px",
    backgroundColor: "#fff",
    color: "#B9B9B9",
    marginBottom: "20px",
    marginTop: "-5px",
    borderRadius: "4px",
  },
  inputText: {
    color: "#666",
    "&:focus": {
      color: "#666",
    },
  },
  labelText: {
    color: "#666",
    "&.Mui-focused": {
      color: "#666",
    },
  },
  textFieldRoot: {
    "& .MuiInput-underline:before": {
      borderBottom: "1px solid #ccc",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: `2px solid ${clientColor}`,
    },
    "& .MuiInput-underline:after": {
      borderBottom: `2px solid ${clientColor}`,
    },
  },
  floatingCard: {
    position: "fixed",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1200,
    backgroundColor: "#fff",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    borderRadius: "0 0 8px 8px",
    padding: "6px 4px 4px 10px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    maxWidth: "90%",
    [theme.breakpoints.down("sm")]: {
      position: "static",
      alignItems: "center",
      maxWidth: "100%",
      transform: "none",
      zIndex: 1200,
      borderRadius: 0,
      margin: "-40px 15px 37px 0",
      backgroundColor: "#EEEE",
      borderBottom: "1px solid " + grayColor[4],
      boxShadow: "none",
    },
  },
  floatingCardTitle: {
    fontSize: "14px",
    color: "#333",
    marginRight: "10px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  iconButtonCustom: {
    cursor: "pointer",
    fontSize: "15px",
    marginLeft: "-5px",
  },
  slider: {
    minWidth: 150, // Define uma largura mínima
    flexGrow: 1, // Permite que o slider cresça para preencher o espaço disponível
    maxWidth: 400, // Define uma largura máxima para não ficar excessivamente grande
    color: clientColor,
    marginTop: "-9px",
    // marginRight: theme.spacing(2), // Adiciona um pouco de margem à direita se necessário
    "& .MuiSlider-thumb": {
      width: 10,
      height: 10,
      backgroundColor: "white",
      border: "2px solid #555555", // Corrigido para um valor hexadecimal válido
      marginTop: "-3px",
    },
    "& .MuiSlider-track": {
      height: 4,
    },
    "& .MuiSlider-rail": {
      height: 4,
      backgroundColor: "#ddd",
    },
    "& .MuiSlider-markLabel": {
      fontSize: "10px",
      color: "#666",
      marginTop: "-6px",
    },
  },
});

// ===================== Kpichartcard Component =====================

const KPIChartCard = ({ kpi }) => {
  /**
   * COMMENT: This component renders a single KPI card, including toggles
   * for monthly/yearly and chart/table views.
   */
  const { t } = useTranslation();
  const { userDetails } = useContext(AuthContext);
  const clientColor = userDetails?.implementation_color;

  const useStyles = makeStyles((theme) =>
    KPIEvolutionStyles(theme, clientColor)
  );
  const classes = useStyles();

  // Local states for toggling

  const [timeAgg, setTimeAgg] = useState("monthly");
  const [viewMode, setViewMode] = useState("chart");

  // == Home: Add the dates slider logic ==

  const rawData = timeAgg === "monthly" ? kpi.data?.monthly : kpi.data?.yearly;
  const allLabels = rawData?.labels || [];
  const [sliderRange, setSliderRange] = useState([0, allLabels.length - 1]);

  // We generate the 'marks' from Slider

  const marks = allLabels
    .map((lbl, idx) => ({
      value: idx,
      label: lbl,
    }))
    .filter((_, idx, arr) => {
      const total = arr.length - 1;
      // Example: display label only at 0%, 25%, 50%, 75%and 100%

      return (
        idx === 0 ||
        idx === total ||
        idx === Math.round(total * 0.25) ||
        idx === Math.round(total * 0.5) ||
        idx === Math.round(total * 0.75)
      );
    });

  // Update the sliderrange if you change the amount of labels (eg Monthly -> Yearly)

  useEffect(() => {
    if (allLabels.length > 0) {
      setSliderRange([0, allLabels.length - 1]);
    }
  }, [allLabels]);

  // Function that returns the text of the Slider label

  function getLabelFromMarks(value, marks) {
    const mark = marks.find((m) => m.value === value);
    return mark ? mark.label : "--";
  }

  // Slider value custom component (similar to Initiative Results Page)

  function ValueLabelComponent(props) {
    const { children, open, value, marks } = props;
    const label = getLabelFromMarks(value, marks);

    return label !== "--" ? (
      <Tooltip open={open} enterTouchDelay={0} placement="top" title={label}>
        {children}
      </Tooltip>
    ) : (
      children
    );
  }

  ValueLabelComponent.propTypes = {
    children: PropTypes.node.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.number.isRequired,
    marks: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.number.isRequired,
        label: PropTypes.string,
      })
    ).isRequired,
  };
  // == End: Add the dates slider logic ==

  const toggleTimeAgg = () => {
    setTimeAgg((prev) => (prev === "monthly" ? "yearly" : "monthly"));
  };
  const toggleViewMode = () => {
    setViewMode((prev) => (prev === "chart" ? "table" : "chart"));
  };

  // For thresholds info pop-up

  const thresholdsInfo = formatThresholds(kpi);

  // Decide which data to show (monthly /yearly)

  // Before we call Rawdata (above). We need to filter now:

  let filteredData = rawData;

  if (!filteredData) {
    return (
      <Typography style={{ textAlign: "center" }}>
        {t("kpispage.data.unavailable")}
      </Typography>
    );
  }

  // We make the logic of slicing the data by Sliderrange

  let [startIndex, endIndex] = sliderRange;
  if (endIndex < startIndex) {
    [startIndex, endIndex] = [endIndex, startIndex];
  }

  if (filteredData && filteredData.labels && filteredData.series) {
    const filteredLabels = filteredData.labels.slice(startIndex, endIndex + 1);
    const filteredSeries = filteredData.series.map((serie) =>
      serie.slice(startIndex, endIndex + 1)
    );
    filteredData = {
      ...filteredData,
      labels: filteredLabels,
      series: filteredSeries,
    };
  }

  return (
    <Card style={{ marginBottom: "16px" }}>
      <CardHeader color="client" icon>
        <CardIcon color="client">
          <FontAwesomeIcon icon={faChartSimple} />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>{kpi.title}</h4>+{" "}
        {/* Home: Add the Slider with the same style as Initiativeresultspage */}
        <div
          style={{
            position: "absolute",
            right: "160px", // Este valor pode estar contribuindo para o aperto
            top: "10px",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            gap: "8px",
            // Tente adicionar um width aqui para o container do slider
            width: "calc(50% - 200px)",
          }}
        >
          <Slider
            value={sliderRange}
            onChange={(event, newValue) => setSliderRange(newValue)}
            ValueLabelComponent={(props) => (
              <ValueLabelComponent {...props} marks={marks} />
            )}
            step={1}
            min={0}
            max={allLabels.length - 1}
            marks={marks}
            disableSwap
            className={classes.slider}
          />
          +{" "}
        </div>
        + {/* End: Add the slider */}
        {/* THRESHOLDS INFO */}
        <div
          style={{
            position: "absolute",
            right: "70px",
            top: "10px",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Tippy
            content={
              <span
                dangerouslySetInnerHTML={{
                  __html: thresholdsInfo,
                }}
              />
            }
            theme="light"
          >
            <Info
              style={{
                fontSize: "18px",
                color: "#666",
                cursor: "pointer",
              }}
            />
          </Tippy>
        </div>
        {/* Time AGGREGATOR TOGGLE */}
        <div
          style={{
            position: "absolute",
            right: "35px",
            top: "10px",
            zIndex: 1000,
          }}
        >
          <Tippy
            content={
              timeAgg === "monthly"
                ? t("kpispage.toggle.yearly")
                : t("kpispage.toggle.monthly")
            }
            arrow={true}
            theme="light"
          >
            <Button
              color="client"
              size="small"
              variant="outlined"
              onClick={toggleTimeAgg}
              className={classes.cardButton}
            >
              <FontAwesomeIcon
                icon={timeAgg === "monthly" ? faCalendarPlus : faCalendarMinus}
                className={classes.cardButtonIcon}
              />
            </Button>
          </Tippy>
        </div>
        {/* Chart/Table toggle */}
        <div
          style={{
            position: "absolute",
            right: "0px",
            top: "10px",
            zIndex: 1000,
          }}
        >
          <Tippy
            content={
              viewMode === "chart"
                ? t("kpispage.toggle.table")
                : t("kpispage.toggle.chart")
            }
            arrow={true}
            theme="light"
          >
            <Button
              color="client"
              size="small"
              variant="outlined"
              onClick={toggleViewMode}
              className={classes.cardButton}
            >
              <FontAwesomeIcon
                icon={viewMode === "chart" ? faTable : faChartLine}
                className={classes.cardButtonIcon}
              />
            </Button>
          </Tippy>
        </div>
      </CardHeader>
      <CardBody style={{ overflow: "hidden", padding: "0" }}>
        <div className={classes.chartContainer}>
          <MixedBarLineChart
            timeAgg={timeAgg}
            viewMode={viewMode}
            data={filteredData}
            trackingMode={kpi.trackingMode}
            thresholdsConfig={kpi.thresholdsConfig}
            /* opcionais – se quiser formatação monetária, porcentagem etc. */
            unit={kpi.unit || ""} // ex.: "R$"  ou "%"
            showUnitBefore={false} // true → "R$ 25"; false → "25 R$"
          />
        </div>
      </CardBody>
    </Card>
  );
};

KPIChartCard.propTypes = {
  kpi: PropTypes.shape({
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    subtype: PropTypes.string.isRequired,
    trackingMode: PropTypes.string.isRequired,
    thresholdsConfig: PropTypes.object.isRequired,
    data: PropTypes.shape({
      monthly: PropTypes.object,
      yearly: PropTypes.object,
    }).isRequired,
  }).isRequired,
};

// ==================== MAIN COMPONENT ====================

const KPIsPage = () => {
  /**
   * COMMENT: Main page that includes both Program KPIs and Initiative KPIs
   * in separate tabs, plus a PDF generation button in a floating card.
   */
  const { userDetails } = useContext(AuthContext);
  const clientColor = userDetails?.implementation_color;
  const useStyles = makeStyles((theme) =>
    KPIEvolutionStyles(theme, clientColor)
  );
  const classes = useStyles();
  const { t } = useTranslation();

  // Tab States: 0 => Program KPIs, 1 => Initiative Kpis
  const [tabIndex, setTabIndex] = useState(0);

  // Data states
  const [programKpisData, setProgramKpisData] = useState([]);
  const [initiativeKpisData, setInitiativeKpisData] = useState([]);
  const [initiativesList, setInitiativesList] = useState([]);

  // Loading states
  const [loadingProgramKpis, setLoadingProgramKpis] = useState(true);
  const [loadingInitiativeKpis, setLoadingInitiativeKpis] = useState(false); // Initially false until an initiative is selected

  // Filter state for Initiative KPIs tab
  const [selectedInitiativeId, setSelectedInitiativeId] = useState("");
  const [includeProjection, setIncludeProjection] = useState(true); // Or false, based on default preference

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
    setSelectedInitiativeId(""); // Reset initiative selection when changing tabs
    setInitiativeKpisData([]); // Clear specific KPIs when changing tabs
  };

  // Fetch Program KPIs on mount
  useEffect(() => {
    const fetchProgramKpis = async () => {
      setLoadingProgramKpis(true);
      try {
        const response = await client.post("/api/kpis-evolution-data/", {
          type: "program",
          include_projection: includeProjection ? 1 : 0,
        });
        if (response.data.success) {
          setProgramKpisData(response.data.data || []);
        } else {
          // console.error("Failed to fetch program KPIs:", response.data.error);
          setProgramKpisData([]);
        }
      } catch (error) {
        // console.error("Error fetching program KPIs:", error);
        setProgramKpisData([]);
      }
      setLoadingProgramKpis(false);
    };

    fetchProgramKpis();
  }, [includeProjection]); // Refetch if includeProjection changes

  // Fetch Initiatives List for dropdown on mount (only once)
  useEffect(() => {
    const fetchInitiativesList = async () => {
      try {
        const response = await client.post("/api/kpis-evolution-data/", {
          type: "initiative", // No initiative_id, backend should return the list
        });
        if (response.data.success) {
          setInitiativesList(response.data.initiatives_list || []);
        } else {
          /*
          console.error(
            "Failed to fetch initiatives list:",
            response.data.error
          );
          */
          setInitiativesList([]);
        }
      } catch (error) {
        // console.error("Error fetching initiatives list:", error);
        setInitiativesList([]);
      }
    };
    fetchInitiativesList();
  }, []);

  // Fetch Specific Initiative KPIs when selectedInitiativeId changes
  useEffect(() => {
    if (selectedInitiativeId && tabIndex === 1) {
      // Only fetch if an initiative is selected and on the correct tab
      const fetchSpecificKpis = async () => {
        setLoadingInitiativeKpis(true);
        setInitiativeKpisData([]); // Clear previous data
        try {
          const response = await client.post("/api/kpis-evolution-data/", {
            type: "initiative",
            initiative_id: selectedInitiativeId,
            include_projection: includeProjection ? 1 : 0,
          });
          if (response.data.success) {
            setInitiativeKpisData(response.data.data || []);
          } else {
            /*
            console.error(
              "Failed to fetch specific initiative KPIs:",
              response.data.error
            );
            */
            setInitiativeKpisData([]);
          }
        } catch (error) {
          // console.error("Error fetching specific initiative KPIs:", error);
          setInitiativeKpisData([]);
        }
        setLoadingInitiativeKpis(false);
      };
      fetchSpecificKpis();
    } else if (!selectedInitiativeId && tabIndex === 1) {
      setInitiativeKpisData([]); // Clear data if no initiative is selected on tab 1
      setLoadingInitiativeKpis(false);
    }
  }, [selectedInitiativeId, tabIndex, includeProjection]); // Also refetch if includeProjection changes

  // Function to group KPIs by subtype
  const getKpisBySubtype = (kpis, subtype) => {
    // Ensure kpis is an array before filtering
    if (!Array.isArray(kpis)) {
      return [];
    }
    return kpis.filter((k) => k.subtype === subtype);
  };

  // Simple function for the responsive layout

  const getGridProps = (kpiCount, index) => {
    if (kpiCount === 1) return { xs: 12, sm: 12, md: 12 };
    if (kpiCount === 2) return { xs: 12, sm: 6, md: 6 };
    if (kpiCount === 3) {
      return index < 2 ? { xs: 12, sm: 6, md: 6 } : { xs: 12, sm: 12, md: 12 };
    }
    return { xs: 12, sm: 6, md: 6 };
  };

  const handlePdfExport = () => {
    const kpisToExport = tabIndex === 0 ? programKpisData : initiativeKpisData;
    let titleForSection =
      tabIndex === 0 ? t("kpispage.tabs.programKpis") : null;

    // DEBUG: Verifique os valores aqui ANTES de chamar generateKpiReportPdf
    // console.log("KPIsPage - userDetails para PDF:", userDetails);
    // console.log("KPIsPage - clientColor para PDF:", clientColor);
    /*
    console.log(
      "KPIsPage - logo base64 para PDF:",
      userDetails?.implementation_logo?.substring(0, 50) + "..."
    );
    */

    if (tabIndex === 1 && selectedInitiativeId) {
      const initiative = initiativesList.find(
        (init) => String(init.id) === String(selectedInitiativeId)
      );
      titleForSection = initiative
        ? `${t("kpispage.tabs.initiativeKpis")}: ${initiative.name}`
        : t("kpispage.tabs.initiativeKpis");
    }

    if (kpisToExport && kpisToExport.length > 0) {
      // Adicione uma verificação para clientColor antes de chamar a função
      if (!clientColor || !/^#[0-9A-F]{6}$/i.test(clientColor)) {
        /*
        console.error(
          "Cor do cliente inválida para PDF:",
          clientColor,
          "Usando cor padrão."
        );
        */
        // Forneça uma cor padrão se clientColor for inválida
        generateKpiReportPdf({
          kpiCardsData: kpisToExport,
          clientColor: "#007bff", // Uma cor padrão, por exemplo azul
          t: t,
          userDetails: userDetails, // Garantir que userDetails está aqui
          reportTitleKey: "kpispage.report.title",
          sectionTitle: titleForSection,
          outputFilename: `KPI_Evolution_Report_${tabIndex === 0 ? "Program" : selectedInitiativeId || "Initiative"}.pdf`,
        });
        return; // Interrompe aqui se a cor for inválida
      }

      generateKpiReportPdf({
        kpiCardsData: kpisToExport,
        clientColor: clientColor, // Agora sabemos que é válida ou foi substituída
        t: t,
        userDetails: userDetails, // Garantir que userDetails está aqui
        reportTitleKey: "kpispage.report.title",
        sectionTitle: titleForSection,
        outputFilename: `KPI_Evolution_Report_${tabIndex === 0 ? "Program" : selectedInitiativeId || "Initiative"}.pdf`,
      });
    } else {
      // console.warn("Nenhum KPI para exportar na aba atual.");
    }
  };
  // Convert strong color to pastel for PDF tables

  function pastelColorToRgb(baseColor) {
    switch (baseColor.toLowerCase()) {
      case "#4caf50":
        return hexToRgbArray("#C8E6C9");
      case "#ffeb3b":
        return hexToRgbArray("#FFF9C4");
      case "#f44336":
        return hexToRgbArray("#FFCDD2");
      default:
        return [255, 255, 255]; // Fallback White
    }
  }

  // ==================== Render =====================

  return (
    <div className={classes.root}>
      {/* Floating bar with PDF button */}
      <div className={classes.floatingCard}>
        <div className={classes.floatingCardTitle}>
          {t("kpispage.report.title")}
        </div>
        <Tooltip title={t("kpispage.report.generate")}>
          <FontAwesomeIcon
            icon={faFilePdf}
            className={classes.iconButtonCustom}
            onClick={handlePdfExport}
          />
        </Tooltip>
      </div>

      <Card style={{ backgroundColor: "#F2F2F2" }}>
        <h4
          className={classes.KPIsEvolutionHeader}
          style={{
            borderBottom: `1px solid rgba(0, 0, 0, 0.05)`,
          }}
        >
          {t("kpispage.evolution.title")}
        </h4>
        <Paper className={classes.tabsContainer}>
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            variant="fullWidth"
            classes={{
              root: classes.tabsRoot,
              indicator: classes.indicator,
            }}
          >
            <Tab
              label={t("kpispage.tabs.programKpis")}
              classes={{ root: classes.tabRoot }}
            />
            <Tab
              label={t("kpispage.tabs.initiativeKpis")}
              classes={{ root: classes.tabRoot }}
            />
          </Tabs>
        </Paper>

        {/* Tab panels */}
        <Box>
          {/* ====== tab 0: Program kpis ====== */}
          {tabIndex === 0 && (
            <div>
              {loadingProgramKpis ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "200px",
                  }}
                >
                  <ThreeDots
                    color={clientColor || "#000000"}
                    height={50}
                    width={50}
                  />
                </div>
              ) : programKpisData.length === 0 ? (
                <Typography style={{ textAlign: "center", marginTop: "20px" }}>
                  {t("kpispage.data.noProgramKpis")}
                </Typography>
              ) : (
                ["topo", "financial", "budget"].map((subtype) => {
                  const kpisForSubtype = getKpisBySubtype(
                    programKpisData,
                    subtype
                  );

                  // Filtra novamente para incluir apenas KPIs com dados
                  const kpisWithData = kpisForSubtype.filter(
                    (kpi) =>
                      kpi.data?.monthly?.labels?.length > 0 ||
                      kpi.data?.yearly?.labels?.length > 0
                  );

                  if (kpisWithData.length === 0) return null; // Se nenhum KPI neste subtipo tem dados, não renderiza o subtipo

                  return (
                    <div key={subtype} style={{ marginBottom: "30px" }}>
                      <Typography
                        variant="h6"
                        style={{ margin: "10px 0 8px 0" }}
                      >
                        {getKpiSubtypeTranslation(t, subtype)}
                      </Typography>
                      <GridContainer spacing={2}>
                        {kpisWithData.map(
                          (
                            kpi,
                            index // Mapeia sobre kpisWithData
                          ) => (
                            <GridItem
                              key={kpi.id || kpi.title}
                              {...getGridProps(kpisWithData.length, index)} // Usa length de kpisWithData
                            >
                              <KPIChartCard kpi={kpi} />
                            </GridItem>
                          )
                        )}
                      </GridContainer>
                    </div>
                  );
                })
              )}
            </div>
          )}

          {/* ====== tab 1: Initiative kpis ====== */}
          {/* ====== tab 1: Initiative kpis ====== */}
          {tabIndex === 1 && (
            <div>
              {/* Initiative selection */}
              <GridItem xs={12} sm={4} md={4} style={{ marginBottom: "20px" }}>
                <TextField
                  fullWidth
                  select
                  value={selectedInitiativeId}
                  onChange={(e) => setSelectedInitiativeId(e.target.value)}
                  label={t("kpispage.specific.initiative")}
                  classes={{ root: classes.textFieldRoot }}
                  InputProps={{ classes: { input: classes.inputText } }}
                  InputLabelProps={{
                    classes: { root: classes.labelText },
                  }}
                >
                  <MenuItem value="">
                    <em>{t("kpispage.specific.select")}</em>
                  </MenuItem>
                  {initiativesList.map((initiative) => (
                    <MenuItem
                      key={initiative.id}
                      value={initiative.id}
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                    >
                      {initiative.name}
                    </MenuItem>
                  ))}
                </TextField>
              </GridItem>

              {/* Render the KPI blocks only if an initiative is selected */}
              {loadingInitiativeKpis ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "200px",
                  }}
                >
                  <ThreeDots
                    color={clientColor || "#000000"}
                    height={50}
                    width={50}
                  />
                </div>
              ) : selectedInitiativeId && initiativeKpisData.length > 0 ? (
                <>
                  {(() => {
                    const subtypes = [
                      "topo",
                      "financial",
                      "budget",
                      "specific",
                    ];
                    let kpiRendered = false;

                    const subtypeContent = subtypes.map((subtype) => {
                      const kpisForSubtype = getKpisBySubtype(
                        initiativeKpisData, // Use fetched data
                        subtype
                      );
                      if (kpisForSubtype.length === 0) return null;

                      kpiRendered = true; // Mark that at least one KPI was found
                      return (
                        <div key={subtype} style={{ marginBottom: "30px" }}>
                          <Typography
                            variant="h6"
                            style={{ margin: "16px 0 8px 0" }}
                          >
                            {/* Translate subtype if needed, e.g., t(`kpispage.subtypes.${subtype}`) */}
                            {getKpiSubtypeTranslation(t, subtype)}
                          </Typography>
                          <GridContainer spacing={2}>
                            {kpisForSubtype.map((kpi, index) => (
                              <GridItem
                                key={kpi.id || kpi.title} // Use kpi.id
                                {...getGridProps(kpisForSubtype.length, index)}
                              >
                                <KPIChartCard kpi={kpi} />
                              </GridItem>
                            ))}
                          </GridContainer>
                        </div>
                      );
                    });

                    // If after checking all subtypes, no KPIs were rendered for the selected initiative
                    if (!kpiRendered && selectedInitiativeId) {
                      return (
                        <Typography
                          variant="body1"
                          style={{ marginTop: "16px", textAlign: "center" }}
                        >
                          {t("kpispage.data.noSpecificKpisForInitiative")}
                        </Typography>
                      );
                    }
                    return subtypeContent;
                  })()}
                </>
              ) : selectedInitiativeId &&
                !loadingInitiativeKpis &&
                initiativeKpisData.length === 0 ? (
                // Selected an initiative, not loading, but no KPIs found
                <Typography
                  variant="body1"
                  style={{ marginTop: "16px", textAlign: "center" }}
                >
                  {t("kpispage.data.noSpecificKpisForInitiative")}
                </Typography>
              ) : (
                // No initiative selected yet
                <Typography
                  variant="body1"
                  style={{ marginTop: "16px", textAlign: "center" }}
                >
                  {t("kpispage.specific.select_initiative")}
                </Typography>
              )}
            </div>
          )}
        </Box>
      </Card>
    </div>
  );
};

export default KPIsPage;
